module.exports = __webpack_public_path__ + "img/all_exam.7cf5696f.png";